const generateUserSpecificKey = (key: string) => {
    return key;
};

const storage = {
    set(key: string, value: any) {
        const userSpecificKey = generateUserSpecificKey(key);
        localStorage.setItem(userSpecificKey, JSON.stringify(value));
    },
    get(key: string) {
        const userSpecificKey = generateUserSpecificKey(key);
        const res = localStorage.getItem(userSpecificKey);
        return res ? JSON.parse(res) : undefined;
    },
    remove(key: string) {
        const userSpecificKey = generateUserSpecificKey(key);
        localStorage.removeItem(userSpecificKey);
    },
    clear() {
        const keysToRemove: string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key) {
                keysToRemove.push(key);
            }
        }

        keysToRemove.forEach((key) => localStorage.removeItem(key));
    },
    // 为了向后兼容，如果需要访问没有用户隔离的原始数据
    getOriginal(key: string) {
        const res = localStorage.getItem(key);
        return res ? JSON.parse(res) : undefined;
    },
    setOriginal(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    removeOriginal(key: string) {
        localStorage.removeItem(key);
    },
};

export default storage;
